import { useEffect, useState } from "react";

//libraries
import { useNavigate, useParams } from "react-router-dom";
import QRCode from "react-qr-code";
import { Snackbar } from "@mui/material";

//api controllers
import { getOrderWithOrderId, getSupportData, sendWhatsapp } from "../services/services";

//icons
import TabCategory from '../assets/svg/bottom tab bar/tabcategory.svg'
import VerifiedIcon from '../assets/svg/verified.svg'
import DownloadIcon from "../assets/svg/download.svg"

//constants
import * as language from '../constants/languages'
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

export default function OrderSucess({ orderData, encryptId, onClose }) {
    const navigate = useNavigate()
    const [currencySymbol, setCurrencySymbol] = useState('₹')

    const [orderPlacedData, setOrderPlacedData] = useState();
    const [whatsInstanceid, setwhatsInstanceid] = useState()
    const [whatsApptoken, setwhatsApptoken] = useState()
    const [snackMessage, setSnackMessage] = useState('');
    const [isSnackopen, setisSnackopen] = useState(false)
    const [whatsAppNo, setwhatsAppNo] = useState()
    const [decryptedId, setDecryptedId] = useState()
    const [encryptedQr, setEncryptedQr] = useState()

    async function getSupportInfoData() {
        try {
            const supportInfoResponse = await getSupportData(language.companyidValue)
            if (supportInfoResponse?.status === 'success') {
                setwhatsAppNo(supportInfoResponse?.data?.whatsApp)
                setwhatsInstanceid(supportInfoResponse?.data?.whatsAppInstanceID)
                setwhatsApptoken(supportInfoResponse?.data?.whatsAppInstanceID)
            }
        } catch (error) {

        }
    }

    async function getOrder() {
        setOrderPlacedData(orderData)
        setEncryptedQr(encryptId)
    }

    const onSnackClose = () => {
        setisSnackopen(false)
    }

    const action = (
        <>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={() => setisSnackopen(false)}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </>
    );

    useEffect(() => {
        getSupportInfoData()
        try {
            const val = localStorage.getItem('companyInfo');
            if (val) {
                const info = JSON.parse(val);
                if (info.currencySymbol) setCurrencySymbol(info.currencySymbol);
            }
        } catch (e) {}
    }, [])

    useEffect(() => {
        getOrder()
    }, [orderData])


    const baseTotal = Number(orderPlacedData?.totalAmount || 0);
    const gstAmount = Math.round(baseTotal * 0.18 * 100) / 100;
    const totalWithGst = Math.round((baseTotal + gstAmount) * 100) / 100;

    return (
        orderPlacedData &&

        <div className="order-success-modal-card" style={{
            backgroundColor: '#ffffff',
            padding: '18px 20px',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            borderRadius: 16,
            width: '100%',
            maxWidth: 440,
            overflow: 'hidden',
            boxSizing: 'border-box',
            boxShadow: '0 20px 50px rgba(0,0,0,0.25)',
            position: 'relative',
            margin: 'auto',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none'
        }}>
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 2 }}>
                <img src={VerifiedIcon} style={{ width: 44, height: 44 }} alt="Order Placed" />
            </div>

            <h2 style={{
                textAlign: 'center',
                fontFamily: 'Montserrat-SemiBold, Poppins-Regular, sans-serif',
                fontSize: 16,
                color: '#1e293b',
                margin: '6px 0 2px 0',
                lineHeight: 1.3
            }}>
                Your order was placed successfully
            </h2>

            {/* QR Code & Order Details side-by-side */}
            <div id="qrDiv" style={{
                display: 'flex',
                alignItems: 'center',
                gap: 14,
                width: '100%',
                backgroundColor: '#f8fafc',
                padding: '10px 12px',
                borderRadius: 12,
                border: '1px solid #edf2f7',
                boxSizing: 'border-box',
                margin: '10px 0 6px 0'
            }}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#ffffff',
                    padding: 6,
                    borderRadius: 8,
                    border: '1px solid #e2e8f0',
                    flexShrink: 0
                }}>
                    <QRCode
                        size={68}
                        value={String(encryptedQr || orderPlacedData?.orderNo || 'Order')}
                        style={{ height: 'auto', maxWidth: 68 }}
                    />
                </div>

                <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 3.5, fontSize: 12, fontFamily: 'Poppins-Regular, sans-serif' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span style={{ color: '#64748b' }}>Order No :</span>
                        <span style={{ fontWeight: 600, color: '#1e293b' }}>{orderPlacedData?.orderNo}</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span style={{ color: '#64748b' }}>Order Date :</span>
                        <span style={{ fontWeight: 600, color: '#1e293b' }}>{orderPlacedData?.orderDate ? new Date(orderPlacedData.orderDate).toLocaleDateString("en-GB") : ''}</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span style={{ color: '#64748b' }}>Customer :</span>
                        <span style={{ fontWeight: 600, color: '#1e293b', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 140 }} title={orderPlacedData?.customerName}>{orderPlacedData?.customerName}</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span style={{ color: '#64748b' }}>Mobile :</span>
                        <span style={{ fontWeight: 600, color: '#1e293b' }}>{orderPlacedData?.orderAddresses?.[0] ? orderPlacedData?.orderAddresses[0].mobileNo1 : ''}</span>
                    </div>
                </div>
            </div>

            {/* Items Table - No scrollbars */}
            <div style={{ width: '100%', boxSizing: 'border-box', margin: '4px 0 6px 0' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12, fontFamily: 'Poppins-Regular, sans-serif' }}>
                    <thead style={{ borderBottom: '1px dashed #cbd5e1', borderTop: '1px dashed #cbd5e1' }}>
                        <tr>
                            <th style={{ textAlign: 'left', padding: '5px 4px', color: '#64748b', fontWeight: 600 }}>Items</th>
                            <th style={{ textAlign: 'center', padding: '5px 4px', color: '#64748b', fontWeight: 600 }}>Qty</th>
                            <th style={{ textAlign: 'right', padding: '5px 4px', color: '#64748b', fontWeight: 600 }}>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {orderPlacedData?.orderItems?.map((item, index) =>
                            <tr key={index} style={{ borderBottom: '1px solid #f1f5f9' }}>
                                <td style={{ textAlign: 'left', padding: '5px 4px', color: '#1e293b' }}>
                                    {item.name}
                                </td>
                                <td style={{ textAlign: 'center', padding: '5px 4px', color: '#64748b' }}>
                                    x{item.quantity}
                                </td>
                                <td style={{ textAlign: 'right', padding: '5px 4px', fontWeight: 600, color: '#1e293b' }}>
                                    {currencySymbol} {item.subTotal}
                                </td>
                            </tr>
                        )}
                        <tr style={{ borderTop: '1px dashed #cbd5e1' }}>
                            <td style={{ textAlign: 'left', padding: '5px 4px', color: '#64748b', fontSize: 12 }}>
                                Subtotal
                            </td>
                            <td></td>
                            <td style={{ textAlign: 'right', padding: '5px 4px', color: '#334155', fontSize: 12, fontWeight: 500 }}>
                                {currencySymbol} {baseTotal.toFixed(2)}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ textAlign: 'left', padding: '3px 4px', color: '#16a34a', fontSize: 11.5, fontWeight: 500 }}>
                                GST (18%)
                            </td>
                            <td></td>
                            <td style={{ textAlign: 'right', padding: '3px 4px', color: '#16a34a', fontSize: 11.5, fontWeight: 500 }}>
                                +{currencySymbol} {gstAmount.toFixed(2)}
                            </td>
                        </tr>
                        <tr style={{ borderTop: '1.5px dashed #94a3b8' }}>
                            <td style={{ textAlign: 'left', padding: '6px 4px', fontWeight: 700, fontSize: 13, color: '#0f172a' }}>
                                Total Amount
                            </td>
                            <td></td>
                            <td style={{ textAlign: 'right', padding: '6px 4px', fontWeight: 700, fontSize: 13.5, color: '#e53935' }}>
                                {currencySymbol} {totalWithGst.toFixed(2)}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <p style={{ fontWeight: 500, color: '#64748b', fontFamily: 'Poppins-Regular', textAlign: 'center', fontSize: 12, margin: '4px 0 10px 0' }}>
                Thank you so much for your order!
            </p>

            <div style={{ display: 'flex', flexDirection: 'column', width: '100%', marginTop: 2 }}>
                <button
                    type="button"
                    style={{
                        backgroundColor: '#1164AF',
                        background: 'linear-gradient(135deg, #1164AF, #0488DD)',
                        padding: '11px 20px',
                        borderRadius: 24,
                        color: '#fff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 10,
                        cursor: 'pointer',
                        border: 'none',
                        fontSize: 14.5,
                        fontFamily: 'Poppins-Regular',
                        fontWeight: 600,
                        boxShadow: '0 4px 14px rgba(17, 100, 175, 0.35)',
                        width: '100%',
                        transition: 'transform 0.15s ease'
                    }}
                    onClick={() => {
                        if (onClose) onClose();
                        navigate('/', { replace: true });
                    }}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 19.223 21.225" stroke='#fff'>
                        <g transform="translate(-3.9 -2.4)">
                            <path d="M4.5,10.009,13.511,3l9.011,7.009V21.023a2,2,0,0,1-2,2H6.5a2,2,0,0,1-2-2Z" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.6" />
                            <path d="M13.5,28.013V18h6.008V28.013" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.6" />
                        </g>
                    </svg>
                    <span>Back to Home</span>
                </button>
            </div>
            <Snackbar
                open={isSnackopen}
                autoHideDuration={2000}
                onClose={onSnackClose}
                message={snackMessage}
                action={action}
                ContentProps={{
                    style: { backgroundColor: '#388E3C' } // ✅ Green
                }}
            />
        </div>
    )

}